import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { DragListCardSettings } from '@common-modules/shared/core/drag-list-card/drag-list-card-settings';
import { DragListCustomSettings } from '@common-modules/shared/core/drag-list-custom/drag-list-custom-settings';
import { LayerItemV2 } from '@common-modules/wlm-map/generic-map/models/layer-item';
import { LayerItem } from '../../models/layer-item';
import { LayerEventsService } from './services/layer-events.service';

@Component({
  selector: 'wlm-layers-selector',
  templateUrl: './layers-selector.component.html',
  styleUrls: ['./layers-selector.component.scss'],
  standalone: false,
})
export class LayersSelectorComponent implements OnInit {
  private _selectedLayerItem: LayerItemV2;
  get selectedLayerItem(): LayerItemV2 {
    return this._selectedLayerItem;
  }
  @Input() set selectedLayerItem(value: LayerItemV2) {
    this._selectedLayerItem = value;
    this._layersService.setSelectedLayerItem(value);
  }

  private _layers: LayerItemV2[];
  public get layers(): LayerItemV2[] {
    return this._layers;
  }
  @Input() public set layers(value: LayerItemV2[]) {
    this._layers = value;
  }
  @Input() map;
  @Input() initialZIndex: number;
  @Input() showLayerTypeIcon: boolean;
  @Input() isDragAndDropEnabled: boolean;
  @Input() isThematic: boolean = false;
  @Input() canConfigure: boolean;

  private _groupPosition: number;
  public get groupPosition(): number {
    return this._groupPosition;
  }
  @Input() public set groupPosition(value: number) {
    this._groupPosition = value;
    // this.compareSignals();
  }
  @Output() layerItemSelected = new EventEmitter<LayerItem>();
  @Output() layerItemsOrderChanged = new EventEmitter<LayerItemV2[]>();
  @Output() layerItemDeleted = new EventEmitter<LayerItemV2>();

  private readonly _layersService = inject(LayerEventsService);
  T_SCOPE = '';

  settingsCustom: DragListCustomSettings;
  cardSettings: DragListCardSettings;
  previusLayer: LayerItem;

  constructor() {}

  ngOnInit(): void {
    this.settingsCustom = new DragListCustomSettings({
      hideFilter: true,
      emptyLegendKey: this.T_SCOPE + '.messages.drag-list-empty-message',
      isReadOnly: false,
    });
  }

  compareSignals() {
    this.layerItemsOrderChanged.emit(this.layers);
  }

  onDroppedElement(event: any): void {}

  onSelectedLayerItem(layerItem: LayerItem) {
    if (!layerItem) {
      this.previusLayer = layerItem;
    }
    this.layerItemSelected.emit(layerItem);
  }

  onDeletedLayerItem(layerItem: LayerItemV2) {
    this.layerItemDeleted.emit(layerItem);
  }
}
